import React from "react";

import {
    Row,
    Col,
    Button,
    Badge
} from "react-bootstrap"

import Image from "../CustomImage"

const toMatrix = (arr, width) =>
    arr.reduce((rows, key, index) => (index % width == 0 ? rows.push([key])
        : rows[rows.length - 1].push(key)) && rows, []);

const CompanyOverview = (data) => {
    const item = data.data.company;
    const location = data.data.locations;//.filter((f) => (f.headquarters));
    const clients = data.data.company.company_clients;


    return (
        // <Row className={"py-3"}>
        <React.Fragment>
            <div id="overview" className="text-block">
                <h3 className="h4 mb-3">Overview</h3>
                <Col>
                    <Row>
                        <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
                            <div className="label-heading">Company size</div>
                            <p className="text-sm fw-bold">
                                {item.company_size.label}
                            </p>
                            <div className="label-heading">Founded</div>
                            <p className="text-sm fw-bold mb-0">
                                {item.company_founded}
                            </p>
                        </Col>
                        <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
                            <div className="label-heading">Hourly rate</div>
                            <p className="text-sm fw-bold">
                                {item.company_hourly_rate.label}
                            </p>
                            <div className="label-heading">Minimal project</div>
                            <p className="text-sm fw-bold mb-0">
                                {item.company_project_minimal_size.label}
                            </p>
                        </Col>
                        <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
                            <div className="label-heading">Headquarters</div>
                            <p className="text-sm fw-bold">
                                {`${location[0].location_city}, ${location[0].location_country?.value}`}
                            </p>
                            <div className="label-heading">Ready to start</div>
                            <p className="text-sm fw-bold mb-0">
                                {item.company_start_time.label}
                            </p>
                        </Col>
                    </Row>
                    {(clients.length > 0) &&
                        <Row>
                            <Col md="12" lg="12" className="pt-3 mb-3 mb-lg-0">
                                <div className="label-heading">Key clients</div>
                            </Col>
                        </Row>
                    }
                    {toMatrix(clients, 4).map((client, index) => (
                        <Row key={index}>
                            {client.map((subclient, subindex) =>
                                <Col key={subindex} xs="6" md="4" lg="3" className="py-0 mb-3 mb-lg-0 ">
                                    <Badge
                                        text="dark secondary text-uppercase text-wrap"
                                        className="d-flex flex-column mb-2 px-1 lg-0 bg-light-gray"
                                    >{subclient.label}
                                    </Badge>
                                </Col>
                            )}
                        </Row>
                    ))}
                </Col>
            </div>
        </React.Fragment>
    )
}

export default CompanyOverview